import { Filter, Sort } from '@empathy/search-types';
import { deepMerge } from '@empathybroker/deep-merge';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { ClientEventCallbacks } from '../../../models';
import { ClientEventsDispatcher } from '../../../services';
import { isArrayEmptyOrNull } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { TRACKING_ACTIONS_KEYS } from '../tracking.const';
import { TrackingAction, TrackingContext } from '../tracking.interfaces';

export class ExtraEventCallbacksAction implements TrackingAction {

  private clientEventsDispatcher: ClientEventsDispatcher;
  private context: TrackingContext;

  actions = {
    [TRACKING_ACTIONS_KEYS.trackFilter]: (context: TrackingContext, filter: Filter) => {
      this.context = context;
      const payload = { filter: deepMerge({}, filter.callbackInfo, { selected: filter.selected }) };
      return this.track(ClientEventCallbacks.filter, payload);
    },
    [TRACKING_ACTIONS_KEYS.trackClearFilters]: (context: TrackingContext) => {
      this.context = context;
      return this.track(ClientEventCallbacks.clearFilters);
    },
    [TRACKING_ACTIONS_KEYS.trackSort]: (context: TrackingContext, sort: Sort) => {
      this.context = context;
      return this.track(ClientEventCallbacks.sort, { sort });
    },
    [TRACKING_ACTIONS_KEYS.trackColumnsChange]: (context: TrackingContext, columns: number) => {
      this.context = context;
      return this.track(ClientEventCallbacks.columnsChange, { columns });
    },
    [TRACKING_ACTIONS_KEYS.trackResultsEnd]: (context: TrackingContext) => {
      this.context = context;
      return this.track(ClientEventCallbacks.resultsEnd);
    },
    [TRACKING_ACTIONS_KEYS.trackOpen]: (context: TrackingContext) => {
      this.context = context;
      return this.track(ClientEventCallbacks.open);
    },
    [TRACKING_ACTIONS_KEYS.trackClose]: (context: TrackingContext) => {
      this.context = context;
      return this.track(ClientEventCallbacks.close);
    }
  };

  track(event: ClientEventCallbacks, payload?: any) {
    this.initDependencies();
    return this.clientEventsDispatcher.dispatch({
      eventName: event,
      data: this.getCallbackData(payload)
    });
  }

  private initDependencies() {
    this.clientEventsDispatcher = this.clientEventsDispatcher ?? container.get<ClientEventsDispatcher>(DEPENDENCIES.ClientEventsDispatcher);
  }

  private getCallbackData(payload: any): any {
    const tagging = this.context.rootState.search.queryTagging ?? { params: {} };
    const resultsInfo = this.context.rootGetters[GETTERS_KEYS.search.resultsCallbackInfo];
    return isArrayEmptyOrNull(resultsInfo) ?
      deepMerge({}, tagging.params, payload) :
      deepMerge({}, tagging.params, { results: resultsInfo }, payload);
  }
}
